import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          color: "#363636",
          backgroundColor: "#ffffff",
          fontSize: "1rem",

          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: ["'Archivo', sans-serif"].join(","),
  },
  fontFamilyArchivo: "'Archivo', sans-serif",
  fontFamilyQuestrial: "'Questrial', sans-serif",
  fontFamilyLexendDeca: "'Lexend Deca', sans-serif",
  whiteColor: "#FFFFFF",
  whiteSmokeColor: "#fafafa",
  darkerWhiteSmokeColor: "#f7f7f7",
  darkestWhiteSmokeColor: "#f0f0f0",
  lighterSnowColor: "#ededed",
  snowColor: "#e8e8e8",
  gainsboroColor: "#dcdcdc",
  silverColor: "#bdbdbd",
  grayColor: "#afafaf",
  dimGrayColor: "#707070",
  darkGrayColor: "#8b8b8b",
  darkSlateGrayColor: "#363636",
  darkerSlateGrayColor: "#303030",
  bisqueColor: "#f5e1c9",
  khakiColor: "#ffe796",
  linenColor: "#fff0e7",
  blanchedAlmondColor: "#feeaca",
  peachPuffColor: "#fdc8b1",
  lightPinkColor: "#fdaeb3",
  lightCoralColor: "#ff8c93",

  backgroundColor: "#ffffff",
  blackColor: "#000000",
  darkerGreyColor: "#363636",
  darkGreyColor: "#404040",
  regularGreyColor: "#5D5D5D",
  lightGreyColor: "#B7B7B7",
  lighterGreyColor: "#EEEEEE",
  lightestGreyColor: "#F5F5F5",

  darkPinkColor: "#F47981",
  pinkColor: "#E9838A",

  lighterPinkColor: "#FFF0E7",
  boxBorder: "2px solid #EEEEEE",
  boxShadow: "0 0 10px #00000015",
  buttonBorder: "1px solid #E6E6E6",
  buttonBorderRadius: "30px",
});

export default theme;
